"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationMetadataEnum = exports.ValidationTypeEnum = void 0;
var ValidationTypeEnum;
(function (ValidationTypeEnum) {
    ValidationTypeEnum["EXISTSANDDEFINED"] = "existsAndDefined";
    ValidationTypeEnum["ALPHABET"] = "alphabetOnly";
    ValidationTypeEnum["MAXLENGTH"] = "maxLength";
    ValidationTypeEnum["MINLENGTH"] = "minLength";
    ValidationTypeEnum["MUSTMATCH"] = "mustMatch";
    ValidationTypeEnum["NUMBER"] = "numberOnly";
    ValidationTypeEnum["GREATERTHAN"] = "greaterThan";
    ValidationTypeEnum["LESSTHAN"] = "lessThan";
    ValidationTypeEnum["GREATERTHANINCLUSIVE"] = "greaterThanInclusive";
    ValidationTypeEnum["LESSTHANINCLUSIVE"] = "lessThanInclusive";
    ValidationTypeEnum["PATTERN"] = "pattern";
    ValidationTypeEnum["REQUIRED"] = "required";
    ValidationTypeEnum["REQUIREUNITS"] = "requireUnits";
    ValidationTypeEnum["RESTRICTFUTURE"] = "restrictFuture";
    ValidationTypeEnum["RESTRICTPAST"] = "restrictPast";
    // DATELESSTHAN was previously named DATEGREATERTHAN and used with an edit check,
    // we need to keep the enum value for backwards compatibility
    ValidationTypeEnum["DATELESSTHAN"] = "dateGreaterThan";
    // DATEGREATERTHAN was previously named DATELESSTHAN and used with an edit check,
    // we need to keep the enum value for backwards compatibility
    ValidationTypeEnum["DATEGREATERTHAN"] = "dateLessThan";
    // Mobile uses an older implementation for 'dateLessThan' and 'dateGreaterThan' edit checks than web activities.
    // For new functionality (e.g., date comparison data points) we want to use the corrected / updated date
    // operators without impacting the existing mobile edit checks.
    ValidationTypeEnum["DATELESSTHAN_CORRECTED"] = "dateLessThanCorrected";
    ValidationTypeEnum["DATEGREATERTHAN_CORRECTED"] = "dateGreaterThanCorrected";
    ValidationTypeEnum["DATELESSTHANINCLUSIVE"] = "dateLessThanInclusive";
    ValidationTypeEnum["DATEGREATERTHANINCLUSIVE"] = "dateGreaterThanInclusive";
    ValidationTypeEnum["DATEEQUALTO"] = "dateEqual";
    ValidationTypeEnum["DATENOTEQUALTO"] = "dateNotEqual";
    ValidationTypeEnum["TODAYSDATE"] = "todaysDate";
    ValidationTypeEnum["GREATERTHANNAV"] = "greaterThanNav";
    ValidationTypeEnum["GREATERTHANINCLUSIVENAV"] = "greaterThanInclusiveNav";
    ValidationTypeEnum["LESSTHANNAV"] = "lessThanNav";
    ValidationTypeEnum["LESSTHANINCLUSIVENAV"] = "lessThanInclusiveNav";
    ValidationTypeEnum["EQUALTONAV"] = "equalToNav";
    ValidationTypeEnum["NOTEQUALTONAV"] = "notEqualToNav";
    ValidationTypeEnum["MULTICHOICECONTAINS"] = "multiChoiceContains";
    ValidationTypeEnum["MULTICHOICEDOESNOTCONTAIN"] = "multiChoiceDoesNotContain";
    ValidationTypeEnum["YES"] = "yes";
    ValidationTypeEnum["NO"] = "no";
    // "equal" is a default json-rules-engine operator, CIRulesEngine does not implement it
    ValidationTypeEnum["EQUALTO"] = "equal";
    // "notEqual" is a default json-rules-engine operator, CIRulesEngine does not implement it
    ValidationTypeEnum["NOTEQUALTO"] = "notEqual";
    ValidationTypeEnum["EQUALTONUM"] = "equalNum";
    ValidationTypeEnum["NOTEQUALTONUM"] = "notEqualNum";
})(ValidationTypeEnum || (exports.ValidationTypeEnum = ValidationTypeEnum = {}));
var ValidationMetadataEnum;
(function (ValidationMetadataEnum) {
    ValidationMetadataEnum["ACTIVITY_START_DATE"] = "ACTIVITY_START_DATE";
    ValidationMetadataEnum["ACTIVITY_START_DATETIME"] = "ACTIVITY_START_DATETIME";
    ValidationMetadataEnum["TASK_START_DATE"] = "TASK_START_DATE";
    ValidationMetadataEnum["TASK_START_DATETIME"] = "TASK_START_DATETIME";
    ValidationMetadataEnum["TASK_END_DATE"] = "TASK_END_DATE";
    ValidationMetadataEnum["TASK_END_DATETIME"] = "TASK_END_DATETIME";
    ValidationMetadataEnum["VISIT_START_DATE"] = "VISIT_START_DATE";
    ValidationMetadataEnum["VISIT_START_DATETIME"] = "VISIT_START_DATETIME";
})(ValidationMetadataEnum || (exports.ValidationMetadataEnum = ValidationMetadataEnum = {}));
